module.exports = __webpack_public_path__ + "static/media/closeMsg.7c7f01c0.svg";